import { QueryConfig } from "store/utils/query-config";

export const tasksDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
